/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import clsx from 'clsx';
import styles from './ProgressIndicator.module.scss';
export const ProgressIndicator = ({ items, activeStep, completedSteps, handleClick, }) => {
    const handleIndicatorClick = (step) => {
        if (completedSteps.includes(step))
            handleClick(step);
    };
    return (<div className={styles.indicatorContainer}>
      {items.map((item) => (<div className={clsx(styles.indicatorItem, activeStep === item.step && styles.active, completedSteps.includes(item.step) && styles.completed)} key={item.label} onClick={() => handleIndicatorClick(item.step)}>
          <div className={styles.indicator}>
            {completedSteps.includes(item.step) && !activeStep !== item.step && (<img src='https://www.haven.com/assets/owners/shared/check.svg' alt='check' role='presentation'/>)}
          </div>
          <p>{item.label}</p>
        </div>))}
    </div>);
};
